// src/Contexts/BaseUrlContext.js
import React, { createContext, useContext } from "react";

const BaseUrlContext = createContext();

const LIVE_API = "https://ycnp.in/application/admin/api";

// Local testing (npm start): go through src/setupProxy.js so login stays saved.
// Live build (npm run build): use the real server URL directly.
const isLocal = process.env.NODE_ENV === "development";

export const BaseUrlProvider = ({ children }) => {
  const baseUrl = isLocal ? "/application/admin/api" : LIVE_API;
  const groupMediaBasePath = "https://ycnp.in/application/group/message"; // Media files base path

  return (
    <BaseUrlContext.Provider value={{ baseUrl, groupMediaBasePath }}>
      {children}
    </BaseUrlContext.Provider>
  );
};

// Custom hook for using baseUrl
export const useBaseUrl = () => useContext(BaseUrlContext);